module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-发布-参与活动.18e48.png";